import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as SettingsIcon } from "../../../assets/svg/settings.svg";
import { setActiveModule } from "../../../actions/sideBarActions";

const SMRSettings = () => {
    const dispatch = useDispatch();
    // useEffect(() => {
    //     let obj = {
    //         // total_sections: 33,
    //         progress_config: {
    //             smr_settings: 1,
    //         },
    //     };

    //     dispatch(configure_getting_started_progress(obj));
    // }, []);
    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                smr_settings: 1,
            },
        };
        localStorage.setItem("activeModule", "Response");
        dispatch(setActiveModule("Response"));
        dispatch(configure_getting_started_progress(obj));
    };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <SettingsIcon className="icon_content fill_svg" />
                        <span className="content_title">Response Settings</span>
                    </div>
                    <div className="text_content">
                        <p>{`This is first step for engaging with your customers on social media`}</p>
                        <p>Settings section will allow you to connect your social media profiles to the Response Module of the platform.</p>
                        <p>
                            {`Click on “Add Pages” to start configuring your accounts. Authenticating your account will help you to respond to messages on those profiles.`}
                        </p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    <Link to="/social-response/settings">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/1l5ZV5bx1Mw"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default SMRSettings;
